module.exports = __webpack_public_path__ + "img/lc.940e9ba9.svg";